// extracted by mini-css-extract-plugin
module.exports = {"main-content":"CheckBoxInput_main-content__3QrJu","checkBoxInput":"CheckBoxInput_checkBoxInput__2rPPy","contentOnly":"CheckBoxInput_contentOnly__214_6"};